<template>
  <div class="bawOrderSubmit" >
    <div class="pageContent">
      <XR-head titleText="订单确认" :rightShow="true" ref="headObj"></XR-head>
      <router-link to="/usercenter/address?redirecturl=/usercenter/address">
        <div class="receive-address">      
          <span style="width:100%;line-height: 40px;font-weight: bold;" v-if="orderInfo.addrId ==0">请选择收货地址</span>    
          <div class="mapIcon" v-if="orderInfo.addrId !=0">
            <i class="fa fa-location"></i>
          </div>
          <div v-if="orderInfo.addrId !=0" class="address-info" :style="{width:addressInfoWidth+'px'}">
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </router-link>

      <div style="margin-bottom:56px;">
      <div class="pro-list" style="padding-bottom:100px;">
        <div class="pro-item" v-for="pItem in productInfoList" :key="pItem.SkuId">
          <div class="pro-img">
            <img :src="pItem.ImgList?pItem.ImgList[0].ImgPath:IMGServer_URL+'/images/index-item-default.png'" />
          </div>
          <div class="pro-info" :style="{width:cartItemProductInfoWidth+'px'}">
            <p class="pro-name">{{pItem.ProductName}}</p>
            <p class="pro-attr">
              <template v-for="attrItem in pItem.AttrList">
                <span :key="attrItem.Id">{{attrItem.Name}}:</span>
                <template v-for="valueItem in attrItem.Values">
                  <span v-if="valueItem.IsSkuValue==1">{{valueItem.Name}} </span>
                </template>
              </template>
            </p>
            <div class="pro-num">
              <p class="pro-price">{{pItem.CandySale.SalePrice}}BAW</p>
              <div class="count">x 1</div>
            </div>
          </div>
        </div>
      </div>
      <div class="choose-info delivery"  @click="open('delivery')">
        <div class="info left">
          <div class="choose-row title">选择配送</div>
        </div>    
        <div class="goIcon" style="line-height: 48px;">
          <i class="fa fa-angle-right"></i>
        </div> 
        <div class="info center" >
          <div class="choose-row">{{shippingMethodName}}</div>
          <div class="choose-row">{{shippingDateName}}</div>
        </div>
        <mu-popup position="bottom" popupClass="bawOrderSubmit-popupLayer delivery" :open="deliveryPopup" @close="close('delivery')">
          <mu-sub-header>请选择送货方式</mu-sub-header>
          <div class="deliveryChoose">
            <template v-for="methodItem in shippingMethodList">
              <mu-raised-button :label="methodItem.method" :class="shippingMethodInfo.id==methodItem.Id?'shippingBtn select':''" @click="selectShippingMethod(methodItem.Id,methodItem.method)"></mu-raised-button>
            </template>
          </div>
          <mu-sub-header>请选择送货时间</mu-sub-header>
          <div class="deliveryChoose">
            <template v-for="dateItem in shippingDateList">
              <mu-raised-button :label="dateItem.method" :class="shippingDateInfo.id==dateItem.Id?'shippingBtn select':''" @click="selectShippingDate(dateItem.Id,dateItem.method)"></mu-raised-button>
            </template>
          </div>
          <mu-raised-button primary @click="choseDelivery()" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>

      <div class="remark">
        <mu-text-field hintText="选填:给商家留言" v-model="orderInfo.remark" fullWidth multiLine :rows="1" :rowsMax="6" helpText="选填:给商家留言" :errorText="multiLineInputErrorText" @textOverflow="handleMultiLineOverflow" :maxLength="50"/>
      </div>

      <div class="price-info">
        <div class="row">
          <p class="title">BAW金额</p>
          <p class="price">
            <span>{{totalPrice}}BAW</span>
          </p>
        </div>
        <div class="row">
          <p class="title">运费</p>
          <p class="price">
            <span>+</span>
            <i class="fa fa-rmb"></i>
            <span>{{freightPrice}}</span>
          </p>
        </div>
      </div>
      </div>
	  <mu-divider />
	  <div class="bottom-bar">
        <mu-row >
          <mu-col width="65" tablet="65" desktop="65">
            <p class="cart-total">
              <span>实付款：</span>
              <span class="money">{{totalPrice}}BAW</span>
              <span class="money" v-if="freightPrice>0"> + <i class="fa fa-rmb"></i>{{freightPrice}}</span>
            </p>
          </mu-col>
          <mu-col width="35" tablet="35" desktop="35">
            <mu-flat-button label="提交订单" class="gobuy" backgroundColor="red" color="white" fullWidth @click="orderSubmit" />
          </mu-col>
        </mu-row>
      </div>            
    </div>
	
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-70) ,
      chooseInfoWidth: (parseInt(document.documentElement.clientWidth)-190) ,      
      deliveryPopup: false,
      fapiaoPopup: false,
      integralPopup: false,
      integral:'',
      productInfoList:[],
      receiveAddress :{},
      totalPrice : 0,
      shippingMethodInfo:{id:0,name:''},
      shippingDateInfo:{id:0,name:''},
      shippingMethodName:'',
      shippingDateName:'',
      orderInfo:{
        invoiceHead:'',
        remark:'',
        skuId:this.$route.query.skuId,
        addrId:0,
        shippingMethodId:0,
        shippingDateId:0
      },
      shippingMethodList:[],
      shippingDateList:[],
      orderNos:[],
      freightPrice: 0
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getDefaultAddress()
    this.getProductDetail()
    this.getShippingDateList()
    this.getShippingMethodList()
    //this.getBawSetting()
  },
  methods: {
    open (obj) {
      this[obj+'Popup'] = true
      if(obj == 'delivery'){
        this.shippingMethodInfo.id = this.orderInfo.shippingMethodId
        this.shippingMethodInfo.name = this.shippingMethodName
        this.shippingDateInfo.id = this.orderInfo.shippingDateId
        this.shippingDateInfo.name = this.shippingDateName
      }
    },
    close (obj) {
      this[obj+'Popup'] = false
    },
    handleMultiLineOverflow (isOverflow) {
      this.multiLineInputErrorText = isOverflow ? '不能超过50个字符' : ''
    },
    getDefaultAddress(){
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetDefaultReceiveAddress"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.hide()
          ths.receiveAddress = res.Data
          ths.orderInfo.addrId = res.Data.Id
          ths.loaded = false
        }
      });
    },
    getFreight(){
      var ths = this
      ths.$post(
        "/Shop/RetailServer/GetFreightByAddressCode",
        JSON.stringify({
          ShoppingMethod: this.orderInfo.shippingMethodId,
          provinceCode:this.receiveAddress.Province,
          cityCode: this.receiveAddress.City,
          areaCode: this.receiveAddress.Area,
          skus: [{skuId: this.orderInfo.skuId, count:1}]
        })
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.$refs.XRtoast.hide()
          ths.loaded = false
          ths.freightPrice = res.Data
        }
      });
    },
    getProductDetail(){
      var ths = this
      
      var skuId = this.$route.query.skuId
      if(skuId){
        skuId = parseInt(skuId)
      }
      if(typeof skuId != "number"){
        return
      }
      var pId = this.$route.query.pId
      var data = {skuId:skuId}

      ths.$post(
        "/Shop/BawServer/getBawProductDetail",
        JSON.stringify(data)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.productInfoList.push(res.Data)
          ths.totalPrice += res.Data.CandySale.SalePrice * 1 
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },    
    getShippingDateList(){    
      var ths = this  
      ths.$post(
        "/Shop/RetailServer/GetShippingDateList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.shippingDateList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    getShippingMethodList(){   
      var ths = this 
      ths.$post(
        "/Shop/RetailServer/GetShippingMethodList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.shippingMethodList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    selectShippingDate(id, name){
      this.shippingDateInfo.id = id
      this.shippingDateInfo.name = name
    },
    selectShippingMethod(id, name){
      this.shippingMethodInfo.id = id
      this.shippingMethodInfo.name = name
    },
    choseDelivery(){
      this.close('delivery')
      if(this.shippingMethodInfo.id<=0){
          this.$refs.XRtoast.failed('请选择送货方式', true)
          return
        }
      if(this.shippingDateInfo.id<=0){
            this.$refs.XRtoast.failed('请选择送货时间', true)
            return
          }  
      this.orderInfo.shippingMethodId = this.shippingMethodInfo.id
      this.shippingMethodName = this.shippingMethodInfo.name
      this.orderInfo.shippingDateId = this.shippingDateInfo.id
      this.shippingDateName = this.shippingDateInfo.name
      this.getFreight()
    },
    orderSubmit(){
      if(this.orderInfo.shippingMethodId==0){
        this.$refs.XRtoast.failed("请选择配送方式", true)
        return
      }
      if(this.orderInfo.shippingDateId==0){
        this.$refs.XRtoast.failed("请选择配送时间", true)
        return
      }
      if(this.multiLineInputErrorText){
        this.$refs.XRtoast.failed("留言不能超过50个字符", true)
        return
      }
      var ths = this
      ths.$post(
        "/Shop/BawServer/BawOrderSubmit",
        JSON.stringify(this.orderInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.orderNos = res.Data
          ths.$refs.XRtoast.success(res.Msg, true)
          cart.clearSelectList()
        }
      });
    },
    submitSuccess(){
      this.$router.push('/baw/orderPay?orderNo='+this.orderNos.join(','))
    }
  },
  watch :{
    productList: function(){
      var price = 0;
      for(var i = 0; i< this.productList.length;i++){
        for(var j = 0; j< this.orderInfo.productList.length;j++){
          if(this.productList[i].SkuId == this.orderInfo.productList[j].skuId){            
            price += this.productList[i].SalePrice * this.orderInfo.productList[j].count
          }
        }
      }
      this.totalPrice = price
    }
  }
}
</script>
<style>
.bawOrderSubmit{
  background: #F0F2F5;
  bottom: unset;
}
.pageContent{
  padding-bottom: 56px;
}

.bawOrderSubmit .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}

.bawOrderSubmit .mapIcon{
  float: left;
  width: 30px;
}

.bawOrderSubmit .receive-address{
  background: white;
  color:black;
  padding: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.bawOrderSubmit .receive-address .address-info{
  float: left;
}
.bawOrderSubmit .receive-address .address-info .name{
  font-size:16px;
  font-weight: 700;
  padding-right: 15px;
}
.bawOrderSubmit .receive-address .address-info .mobile{
  font-size:16px;
  font-weight: 700;
}
.bawOrderSubmit .receive-address .address-info .address-content{
  font-size:12px;
  line-height: 18px;
  color:#999;
}
.bawOrderSubmit .receive-address .address-info .address-content .fa{
  width: 20px;
}

.bawOrderSubmit .choose-info{
  overflow: hidden;
  padding:10px;
  background: white;
  margin-top: 10px;
}
.bawOrderSubmit .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.bawOrderSubmit .choose-info .info.center{
  float: right;
}
.bawOrderSubmit .choose-info .info.left .title{
  font-size: 14px;
  font-weight: 700;
}
.bawOrderSubmit .choose-info .info .choose-row{
  line-height: 24px;
}
.bawOrderSubmit .choose-info .info.center .choose-row{
  text-align: right;
}
.bawOrderSubmit .choose-info.integral .info.left .choose-row.balance{
  color:red;
}

.bawOrderSubmit .remark{
  background: white;
  margin-top: 10px;
  padding:10px 10px 0;
}

.bawOrderSubmit .price-info{
  background: white;
  margin-top: 10px;
  padding:10px 10px;
}
.bawOrderSubmit .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.bawOrderSubmit .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.bawOrderSubmit .price-info .row .price{
  color:Red;
  font-weight: 700;
}



.bawOrderSubmit .pro-list{
  margin-top: 10px;
  background: white;
  overflow: hidden;
}
.bawOrderSubmit .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.bawOrderSubmit .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.bawOrderSubmit .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  margin: 0 20px;
}
.bawOrderSubmit .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.bawOrderSubmit .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
}
.bawOrderSubmit .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
}
.bawOrderSubmit .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.bawOrderSubmit .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.bawOrderSubmit .pro-list .pro-item .pro-info .pro-num .count{
  font-size: 12px;
  line-height: 16px;
  color:#999;
  float: right;
}




.bawOrderSubmit .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
  z-index: 9999;
}
.bawOrderSubmit .bottom-bar .cart-total{
  float: left;
  height: 56px;
  line-height: 56px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 700;
  color:Red;
}
.bawOrderSubmit .gobuy{
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
}

.bawOrderSubmit-popupLayer {
  width: 100%;
  min-height: 120px;
}
.bawOrderSubmit-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.bawOrderSubmit-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.bawOrderSubmit-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}

</style>



// WEBPACK FOOTER //
// src/pages/baw/orderSubmit.vue